import React, { PureComponent } from 'react';
import { Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Animated } from "react-animated-css";
import { connect } from 'react-redux';

//IMAGES
import CartIcon from "../images/svgs/cart.svg"
import Delete from "../images/svgs/Delete.svg"
import CloseRum from "../images/svgs/SocialMediaMenu/CloseRum.svg"

import * as actionCreators from "../store/actions"

class CartMenu extends PureComponent {
  redirectToDetail = () => {
    // console.log('props', this.props);
    this.props.history.push({
      pathname: `/clientwebsite2/productDetail/${this.props.media.instagram_pid}`,
      // Change later to /productDetail
      state: {
        media: this.props.media,
        whatsappLink: this.props.whatsappLink,
        businessName: this.props.businessName,
      },
    });
  };
  calculateTotal = () => {
    let priceTotal = [0];
    priceTotal = this.props.cartList && this.props.cartList
      .map(pr => pr.price)

    priceTotal = priceTotal && priceTotal.reduce((prev, curr) => parseFloat(prev) + parseFloat(curr), 0)

    return priceTotal
  }
  render() {
    const { closeCartMenu, currency, translate, cartList, bucketExpaned } = this.props;
    return (
      <Animated
        animationIn="slideInRight"
        animationOut="slideOutRight"
        isVisible={bucketExpaned}
        className={"bucketListOuterView"}
      >

        <div className={"myCartHeader"}>
          <Image
            className={"myCartIcon"}
            src={CartIcon}
          />
          <h3 className={"shoppingCartText"}>{translate['Shopping Cart']}</h3>
          <span className={"closebtnSpan"} onClick={closeCartMenu}>
            <Image src={CloseRum} />
          </span>
        </div>
        <div className={"bucketListScrollView"} style={{ height: window.innerHeight - 235 }}>
          {cartList && cartList.length === 0 &&
            <div>
              <p className={"emptyCartText"}>
                {translate['Hey, it feels so light']}
              </p>
              <p className={"emptyCartText emptyCartSubText"}>
                {translate['There is nothing in your cart']}
              </p>
            </div>}
          {
            cartList && cartList.map(data => {

              return (<div className={"bucketRow"} key={data.id}>
                <Image src={data.media_url} />
                <div className={"qtyBtnDiv"}>
                  <span onClick={() => {
                    if (data.quantity === 1) {
                      return false
                    }
                    this.props.reduceProductQuantity(data.id)
                  }} className={"qtyBtn reduceQty"}>-</span>
                  <input disabled={true} value={data.quantity} className={"prodQty"} />
                  <span
                    onClick={() => { 
                    this.props.addProductToMyCart(data.id)
                    }}
                    className={"qtyBtn addQty"}>+
                  </span>
                </div>
                <div className={"bucketInnerDiv"}>
                  <div className={"firstRow"}>
                    <p className="prodName">
                      {data.name}
                    </p>
                    <p className={"priceBox"}>
                      <span>{currency}</span> {data.price}
                    </p>
                  </div>


                </div>
                <Image src={Delete} className={"removeFromCartText"}
                  onClick={() => {
                    if (window.confirm("Are you sure you want to remove this product from your cart ?")) {
                      this.props.removeProductFromMyCart(data.id)
                    }
                  }} />

              </div>)
            })
          }
        </div>

        {cartList && cartList.length !== 0 && <div className={"checkoutBottomView"}>
          <div className={"totalPriceView"}>
            <h5 className={"totalPriceText"}>
              {"Cart Total:"}
            </h5>
            <h5 className={"totalPriceAmountText"}>
              <span>{this.props.currency}</span>
              {this.props.totalCartAmount}
            </h5>
          </div>
          <button className={"continueShoppingButton"} onClick={() => {
            closeCartMenu()
            this.props.history.replace("/clientwebsite2")
          }}>
            {"Continue Shopping"}
          </button>
          <button className={"checkoutButton"} onClick={() => { this.props.history.push("/clientwebsite2/address") }}>
            {translate['Proceed to checkout']}
          </button>
        </div>}
      </Animated>

    );
  }
}
const mapDispatchToProps = dispatch => ({
  myCartList: () => dispatch(actionCreators.myCartList()),
  removeProductFromMyCart: (product_id) => dispatch(actionCreators.removeProductFromMyCart(product_id)),
  addProductToMyCart: (product_id) => dispatch(actionCreators.addProductToMyCart(product_id)),
  reduceProductQuantity: (product_id) => dispatch(actionCreators.reduceProductQuantity(product_id))
});
const mapStateToProps = state => ({

  pathname: state.login.pathname,
  translate: state.websiteLanguage.translations,
  featuredProductsList: state.campaign.featuredProductsList,
  popularProductsList: state.campaign.popularProductsList,
  explore_products: state.campaign.explore_products,
  currency: state.login.currency,
  cartList: state.cart.cartList,
  totalCartAmount: state.cart.totalCartAmount

});
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CartMenu));



// WEBPACK FOOTER //
// ./src/components/CartMenu.js